import React from "react";
import { Route, Switch } from "react-router-dom";
import Root from "./Root";
import ScrollToTop from "./ScrollToTop";
import store, { history } from "../store";
import { Provider } from "react-redux";
import Head from "./Head";
import { ConnectedRouter } from "react-router-redux";

class Router extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <ScrollToTop>
                        <Head />
                        <Switch>
                            <Route render={props => <Root />} />
                        </Switch>
                    </ScrollToTop>
                </ConnectedRouter>
            </Provider>
        );
    }
}

export default Router;



// WEBPACK FOOTER //
// ./src/components/Router.js